export const getAllCompanyDocuments = (api, tokenType) => {
  return api.get(`/companyDocuments`, {
    tokenType,
  });
};

export const getCandidateFilledCompanyDocuments = (api, payload, tokenType) => {
  const { id } = payload
  return api.get(`/companyDocuments/DocumentMaping/candidateId/${id}`, {
    tokenType,
  });
};

export const getCandidateDeclarationDocument = (api, tokenType) => {
  return api.get(`/companyDocuments`, {
    tokenType,
  });
};
